import React from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
import { Constants as AppConstants } from 'shared/resources/Constants';

export const Loader = React.memo(({ children, loading, color, size }) =>
	<>
		{!(!loading) && <PulseLoader size={size ? size : 10} color={color ? color : AppConstants.LOADER_COLOR} loading />}
		{!loading && <>{children}</>}
	</>
)

export const BoxLoader = React.memo(({ children, loading, color, size }) =>
	<>
		{!!loading &&
			<div className="fixed h-screen w-screen top-0 left-0 z-50 bg-gray opacity-50 flex items-center justify-center">
				<PulseLoader size={size ? size : 30} color={color ? color : AppConstants.LOADER_COLOR} loading />
			</div>}
		{children}
	</>
)

